import React from "react";
import { Box, Grid2, LinearProgress } from "@mui/material";
import { OcRoleFilterSubtypeCollapse } from "../role-filter-subtype-collapse";
import { OcRoleFilterSubtypeHeader } from "../role-filter-subtype-header";
import { useOcRoleFilterSubtype } from "./use-role-filter-subtype";
import { RoleFilterInput } from "oc/types";

type OcRoleFilterSubtypeViewProps = {
  type: keyof RoleFilterInput;
  isCheckbox?: boolean;
  editable?: boolean;
} & ReturnType<typeof useOcRoleFilterSubtype>;

export const OcRoleFilterSubtypeView: React.FC<
  OcRoleFilterSubtypeViewProps
> = ({ loading, isDisabled, ...props }) => {
  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
      <Box>
        <OcRoleFilterSubtypeHeader {...props} disabled={isDisabled} />
        {loading && <LinearProgress sx={{ marginBottom: "-4px" }} />}
        <OcRoleFilterSubtypeCollapse {...props} />
      </Box>
    </Grid2>
  );
};
